import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-clinical-blue pt-12 pb-8 sm:pt-20 sm:pb-10 text-white" data-id="element-99" data-mp="3gg0zo4mhnzy6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100" data-mp="32ovw4rg02nik">
        <div className="grid lg:grid-cols-3 gap-10 sm:gap-12 mb-12 sm:mb-20" data-id="element-101" data-mp="36pftnw4hjt58">
          <div className="lg:col-span-1" data-id="element-102" data-mp="36nd5ziqt2c3o">
            <span className="text-xl sm:text-2xl font-black tracking-tight text-white uppercase block mb-4 sm:mb-6" data-id="element-103" data-mp="3ueih5klswg7n">
              Daily Care Pharmacy
            </span>
            <p className="text-blue-100 text-sm leading-relaxed max-w-xs" data-id="element-104" data-mp="3lecaahklyehg">
              Your trusted local digital pharmacy, providing professional care
              and wellness essentials to our communities.
            </p>
          </div>

          <div data-id="element-105" data-mp="29y5gjzn2fiuh">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-106" data-mp="29xlzsm95j0i1">
              Annapolis Store
            </h4>
            <div className="space-y-6" data-id="element-107" data-mp="3l9k6xg5ljtev">
              <p className="text-white text-base font-medium" data-id="element-108" data-mp="3lalgfg6ys7uh">
                2002 Jennifer Rd
                <br data-id="element-109" data-mp="3gbiliokp7i08" />
                Annapolis, MD 21401
              </p>
              <div className="text-sm text-blue-100 space-y-1" data-id="element-110" data-mp="3v89cqak7xner">
                <p data-id="element-111" data-mp="3v5n6qfcz7fyn">Mon - Fri: 9:00 AM - 7:00 PM</p>
                <p data-id="element-112" data-mp="3q8dhazpl74at">Sat: 10:00 AM - 4:00 PM</p>
                <p data-id="element-113" data-mp="3qaq1ljithqr1">Sun: Closed</p>
              </div>
              <a href="#" className="text-white font-bold text-xs uppercase tracking-widest hover:underline flex items-center gap-2" data-id="element-114" data-mp="828qmgkzanef">
                Google Business Profile <ExternalLinkIcon className="w-4 h-4" data-id="element-115" data-mp="hrs7jgp4s76n" />
              </a>
            </div>
          </div>

          <div data-id="element-116" data-mp="cv1s8vl5hfma">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-300 mb-8" data-id="element-117" data-mp="cuiku8t4m9mi">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-118" data-mp="mrwm316haru8">
              <li data-id="element-119" data-mp="msy4jqptqglz">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-120" data-mp="mtrbossp384n">
                  Prescriptions
                </a>
              </li>
              <li data-id="element-121" data-mp="13tke644cwbdz">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-122" data-mp="13t0uoiz25exu">
                  OTC Products
                </a>
              </li>
              <li data-id="element-123" data-mp="1clckc2mckycr">
                <a href="#" className="text-white text-sm font-bold uppercase tracking-widest hover:text-blue-200" data-id="element-124" data-mp="1cnyqpyxi57te">
                  Vaccines
                </a>
              </li>
              <li data-id="element-125" data-mp="1rjep2g547pvl">
                <a href="#" className="text-blue-200 text-sm font-bold uppercase tracking-widest hover:underline" data-id="element-126" data-mp="1rhtvasqmkays">
                  The VIEW (DC Admin)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-127" data-mp="2afdh79cf72n7">
          <p className="text-blue-200 text-xs font-bold uppercase tracking-widest" data-id="element-128" data-mp="25nls738wx4z6">
            © 2026 DAILY CARE PHARMACY.
          </p>
          <div className="flex gap-8" data-id="element-129" data-mp="21kfkrsa2d7r4">
            <Link to="/privacy" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-130" data-mp="1woi8bx1x8ljm">
              Privacy
            </Link>
            <Link to="/terms" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-131" data-mp="2pdpd3dryy7db">
              Terms
            </Link>
            <Link to="/hipaa" className="text-blue-200 hover:text-white text-xs font-bold uppercase tracking-widest transition-colors" data-id="element-132" data-mp="2fdylpkypg8hg">
              HIPAA
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}